import React from "react";
import { string } from "prop-types";
import Block from "../Block";

const Spinner = ({ text = "Working ..." }) => {
	return (
		<Block className="spinner-overlay">
			<Block spacing={{ p: 3 }} sx={{ textAlign: "center" }} className="spinner-wrapper">
				<Block role="status" className="spinner-border">
					{text && <span className="sr-only">{text}.</span>}
				</Block>
				{text && (
					<Block spacing={{ mt: 2 }} sx={{ fontWeight: "medium" }}>
						{text}
					</Block>
				)}
			</Block>
		</Block>
	);
};

Spinner.propTypes = {
	text: string,
};

export default Spinner;
